/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 2.2046 pounds. The exact relationship is defined the other way: one pound equals exactly 453.59237 grams, so a kilogram (1,000 grams) works out to 1000 ÷ 453.59237 ≈ 2.2046 pounds. This is why body weight and luggage limits convert to a slightly awkward decimal rather than a round number.`)
};

const es_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproximadamente 2.2046 libras. La relación exacta se define de la otra manera: una libra equivale exactamente a 453.59237 gramos, así que un kilogramo (1,000 gramos) resulta en 1000 ÷ 453.59237 ≈ 2.2046 libras. Por eso el peso corporal y los límites de equipaje se convierten a un decimal ligeramente incómodo en lugar de un número redondo.`)
};

const de_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwa 2.2046 Pfund. Das exakte Verhältnis ist andersherum definiert: Ein Pfund entspricht genau 453.59237 Gramm, sodass ein Kilogramm (1,000 Gramm) 1000 ÷ 453.59237 ≈ 2.2046 Pfund ergibt. Deshalb ergeben Körpergewicht und Gepäckgrenzen bei der Umrechnung eine leicht unrunde Dezimalzahl statt einer glatten Zahl.`)
};

const nl_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeveer 2,2046 pond. De exacte relatie is op de andere manier gedefinieerd: één pond is exact gelijk aan 453.59237 gram, dus een kilogram (1.000 gram) werkt uit naar 1000 ÷ 453.59237 ≈ 2.2046 pond. Dit is waarom lichaamsgewicht en bagage limieten converteren naar een enigszins onhandig decimaal in plaats van een rond getal.`)
};

const fr_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environ 2,2046 livres. La relation exacte est définie de l'autre côté : une livre égale exactement 453,59237 grammes, donc un kilogramme (1 000 grammes) se résout à 1000 ÷ 453,59237 ≈ 2,2046 livres. C'est pourquoi le poids corporel et les limites de bagages se convertissent en une décimale légèrement maladroite plutôt qu'un nombre rond.`)
};

const it_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Circa 2.2046 libbre. La relazione esatta è definita nell'altro modo: una libbra equivale esattamente a 453,59237 grammi, quindi un chilogrammo (1.000 grammi) funziona a 1000 ÷ 453,59237 ≈ 2.2046 libbre. È per questo che il peso corporeo e i limiti di bagaglio si convertono in un decimale leggermente imbarazzante piuttosto che in un numero rotondo.`)
};

const pt_br2_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de 2.2046 libras. A relação exata é definida de outra forma: uma libra é igual a exatamente 453.59237 gramas, então um quilograma (1.000 gramas) funciona para 1000 ÷ 453.59237 ≈ 2.2046 libras. É por isso que o peso corporal e os limites de bagagem são convertidos para um decimal um pouco desajeitado em vez de um número redondo.`)
};

const pt_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de 2,2046 libras. A relação exacta é definida de outra forma: uma libra é exactamente igual a 453,59237 gramas, portanto um quilograma (1000 gramas) resulta em 1000 ÷ 453,59237 ≈ 2,2046 libras. É por isto que o peso corporal e os limites de bagagem convertem para um decimal ligeiramente desajustado em vez de um número arredondado.`)
};

const ja_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`約2.2046ポンド。正確な関係は逆に定義されています。1ポンドは正確に453.59237グラムに等しいため、1キログラム(1,000グラム)は1000 ÷ 453.59237 ≈ 2.2046ポンドになります。これが、体重と荷物制限が小数ではなく奇妙な小数に変換される理由です。`)
};

const zh_uc_wt_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq1_a", locale)
	if (locale === "en") return en_uc_wt_faq1_a(inputs)
	if (locale === "es") return es_uc_wt_faq1_a(inputs)
	if (locale === "de") return de_uc_wt_faq1_a(inputs)
	if (locale === "nl") return nl_uc_wt_faq1_a(inputs)
	if (locale === "fr") return fr_uc_wt_faq1_a(inputs)
	if (locale === "it") return it_uc_wt_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq1_a(inputs)
	if (locale === "pt") return pt_uc_wt_faq1_a(inputs)
	if (locale === "ja") return ja_uc_wt_faq1_a(inputs)
	return zh_uc_wt_faq1_a(inputs)
};